
import { Vue, Component, toNative } from 'vue-facing-decorator';
import ParticipantPageHeader from '@/components/Participants/ParticipantPageHeader.vue';
import ParentParticipantGrid from '@/components/Participants/ParentParticipantGrid.vue';
import { Root } from '@/main';

@Component({
  components: { ParticipantPageHeader, ParentParticipantGrid },
})
class Attendees extends Vue {
  private mounted() {
    Root.emit('set-active-component', 'attendee');
  }
}
export default toNative(Attendees);
